// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__2TP-j","more":"styles_more__Dc__9"};